import React from 'react';

const Header = () => {
  return (
    <header id="main-header" className="main-header">
      <nav className="navbar navbar-expand-lg">
        <div className="container-xl nav-container-dt">
          <a className="navbar-brand" href="/">
            <img src="assets/img/logo.svg" alt="logo" />
          </a>
          <button className="navbar-toggler" type="button">
            <i /><i /><i />
          </button>
          <div className="" id="main-navigation">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <i className="drop-dropdown-icon" />
                <a className="nav-link" href="/our-services">Our Services</a>
                <div className="dropdown-menu">
                  <a href="/abm">Account-Based Marketing</a>
                  <a href="/ContentMarketing">Content Marketing</a>
                  <a href="/LeadGeneration">Lead Generation</a>
                  <a href="/WebDesign">Website Design and Development</a>
                  <a href="/SEO">Search Engine Optimization (SEO)</a>
                  <a href="/SocialMarketing">Social Media Marketing</a>
                  <a href="/EmailMarketing">Email Marketing</a>
                  <a href="/ppc">Paid Advertising</a>
                  <a href="/MarketingAutomation">Marketing Automation</a>
                </div>
              </li>
              <li className="nav-item dropdown">
                <i className="drop-dropdown-icon" />
                <a className="nav-link" href="/">About Us</a>
                <div className="dropdown-menu">
                  <a className="" href="/OurStory">Our Story</a>
                  <a className="" href="/portfolio">Portfolio</a>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/SuccessStories">Success Stories</a>
              </li>
              <li className="nav-item dropdown">
                <i className="drop-dropdown-icon" />
                <a className="nav-link" href="/">Resources</a>
                <div className="dropdown-menu">
                  <a className="" href="/">Blog</a>
                  <a className="" href="/ebook">E-Book</a>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/Contact">Contact</a>
              </li>
              <li className="nav-item">
                <a className="nav-link calandy" href="#.html" />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
